
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlusCircle } from 'lucide-react';
import Button from '@/components/ui-elements/button';
import { useRewardManagement } from '@/hooks/useRewardManagement';
import RewardForm from './rewards/RewardForm';
import RewardsTable from './rewards/RewardsTable';

const RewardCampaigns = () => {
  const { t } = useTranslation();
  const {
    rewards,
    loading,
    isAddingNew,
    setIsAddingNew,
    editingReward,
    formValues,
    handleInputChange,
    handleSubmit,
    resetForm,
    handleEdit,
    handleDelete,
    handleToggleActive
  } = useRewardManagement();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">{t('admin.rewardCampaigns')}</h2>
        {!isAddingNew && (
          <Button 
            onClick={() => setIsAddingNew(true)}
            leftIcon={<PlusCircle className="h-4 w-4" />}
          >
            {t('admin.addNewReward')}
          </Button>
        )}
      </div>

      {isAddingNew && (
        <RewardForm
          editingReward={editingReward}
          formValues={formValues}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          resetForm={resetForm}
        />
      )}

      <RewardsTable
        rewards={rewards}
        loading={loading}
        handleEdit={handleEdit}
        handleToggleActive={handleToggleActive}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default RewardCampaigns;
